import Button from "@/components/atoms/Button";
import Input from "@/components/atoms/Input";
import {
  Select,
  SelectTrigger,
  SelectItem,
  SelectContent,
  SelectValue,
} from "@/components/atoms/Select";
import { Trash2 } from "lucide-react";
import { ControllerRenderProps, UseFormReturn } from "react-hook-form";

export type Threshold = {
  status: string | null;
  threshold: number;
};

type ThresholdListProps = {
  form: UseFormReturn<any>;
  field: ControllerRenderProps<any, any>;
  edit: boolean;
  thresholds: Threshold[];
  ticket_statuses: any[];
  setThresholds: (t: Threshold[]) => void;
};

const ThresholdList = ({
  edit,
  form,
  field,
  thresholds,
  ticket_statuses,
  setThresholds,
}: ThresholdListProps) => (
  <div>
    {thresholds.map((threshold, index) => (
      <div className="flex items-center my-3 gap-2" key={index}>
        <Select
          value={threshold?.status || ""}
          onValueChange={(e) =>
            setThresholds(
              thresholds.map((t, ind) =>
                ind === index
                  ? {
                      ...t,
                      status: e,
                    }
                  : t
              )
            )
          }
          disabled={!edit}
        >
          <SelectTrigger className="w-[180px]">
            <SelectValue placeholder="Select Status" />
          </SelectTrigger>
          <SelectContent>
            {ticket_statuses.map((ticketStatus) => (
              <SelectItem key={ticketStatus.id} value={`${ticketStatus.id}`}>
                {ticketStatus.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <Input
          placeholder="Threshold"
          className="w-24"
          danger={!!form.formState.errors[field.name]}
          type="number"
          value={threshold.threshold}
          disabled={!edit}
          onChange={(e) =>
            setThresholds(
              thresholds.map((t, ind) =>
                ind === index
                  ? {
                      ...t,
                      threshold: parseInt(e.currentTarget.value),
                    }
                  : t
              )
            )
          }
        />
        <Button
          disabled={!edit}
          size="sm"
          onClick={() =>
            setThresholds(thresholds.filter((_, ind) => ind !== index))
          }
        >
          <Trash2 size={18} />
        </Button>
      </div>
    ))}
    <Button
      type="button"
      disabled={!edit}
      onClick={() =>
        setThresholds([...thresholds, { status: null, threshold: 0 }])
      }
    >
      Add Threshold
    </Button>
  </div>
);

export default ThresholdList;
